/* eslint-disable import/prefer-default-export */
import fetch from 'isomorphic-unfetch';
import config from '../../../config';

const { apiHost } = config;

const getDinglesPageContent = () => async dispatch => {
    dispatch({
        type: 'DINGLES_PAGE_CONTENT_V2:FETCH_CONTENT_REQUEST',
    });
    const res = await fetch(`${apiHost}/v2/content/dingles-page`);
    const data = await res.json();

    if (data.error) {
        dispatch({
            type: 'DINGLES_PAGE_CONTENT_V2:FETCH_CONTENT_FAILURE',
            data: data.error,
        });
    } else {
        dispatch({
            type: 'DINGLES_PAGE_CONTENT_V2:FETCH_CONTENT_SUCCESS',
            data: data.contentSlices,
        });
    }
};

export default getDinglesPageContent;
